import Vue from 'vue'
import Router from 'vue-router'
import {store} from '../store/store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');
const LoginConenedor = () => import('@/containers/Login');

// Views
const Inicio = () => import('@/views/Inicio');

// Views - Recepcion
const Ingreso = () => import('@/views/recepcion/Ingreso');
const List = () => import('@/views/recepcion/List');
const Consultas = () => import('@/views/recepcion/Consultas');

// Views - Procesos
const IngresoProceso = () => import('@/views/procesos/IngresoProceso');
const IngresoProcesoyReproceso = () => import('@/views/procesos/IngresoProcesoYReproceso');
const IngresoRepaletizaje = () => import('@/views/procesos/IngresoRepaletizaje');
const ProcessList = () => import('@/views/procesos/List');

// const Consultas = () => import('@/views/procesos/Consultas');

// Views - Camara
const Stock = () => import('@/views/camara/Stock');
const Position = () => import('@/views/camara/Position');
const Dispatched = () => import('@/views/camara/Dispatched');
const StockCastana = () => import('@/views/camara/StockCastana');

// Views - Reportes
const Excel = () => import('@/views/reportes/Excel');
const Dashboard = () => import('@/views/reportes/Dashboard');

// Views - Despacho
const IngresoDespacho = () => import('@/views/despacho/IngresoDespacho')
const ListDespacho = () => import('@/views/despacho/List')
const DetalleDespacho = () => import('@/views/despacho/DetalleDespacho')

// Views - Materiales
const CreateSupplyWaybill = () => import('@/views/supplies/CreateSupplyWaybill');
const ListSupplies= () => import('@/views/supplies/List');
const StockSupplies= () => import('@/views/supplies/Stock');
const MappingList= () => import('@/views/supplies/MappingList');


// Views - Proforma
const CreateProforma= () => import('@/views/comercial/CreateProforma');
const ProformaList= () => import('@/views/comercial/ProformaList');

// Views - Exportacion
const InstruccionEmbarque = () => import('@/views/exportacion/InstruccionEmbarque');
const ListInstruccionEmbarque = () => import('@/views/exportacion/List');
const InspeccionEmbarque = () => import('@/views/exportacion/Inspeccion');
const ListInspecciones = () => import('@/views/exportacion/ListInspecciones');
const formAprobarPallet = () => import('@/views/exportacion/formAprobarPallet');
const ListaEmbarque = () => import('@/views/exportacion/ListaEmbarque');
const guiaDespachoExportacion = () => import('@/views/exportacion/guiaExportacion/guiaDespachoExportacion');
const ListGuiaExportacion = () => import('@/views/exportacion/guiaExportacion/ListGuiaExportacion');

//Calidad
const ListCalidad = () => import('@/views/calidad/List');
const ListProcess = () => import('@/views/calidad/ListProcess');
const DetailedLot = () => import('@/views/calidad/DetailedLotInspection');
const ReportExcel = () => import('@/views/calidad/ReportExcel');
const ListEvaluationsReception = () => import('@/views/calidad/ListEvaluationsReception');
const ListEvaluationsProcess = () => import('@/views/calidad/ListProcessEvaluationsProcess');



//Trazabilidad
const Traceability = () => import('@/views/traceability/MainTraceability.vue');
const DetailedTraceability = () => import('@/views/traceability/DetailedTraceability.vue');
const DetailedRepaletizajeProcess = () => import('@/views/traceability/DetailedRepaletizajeProcess.vue');
const DetailedWaybillReception = () => import('@/views/traceability/DetailedWaybillReception.vue');
const DetailedPalletTrazability = () => import('@/views/traceability/DetailedPalletTrazability.vue');
const DetaildedProcess = () => import('@/views/traceability/DetaildedProcess.vue');
const DetailedRepaletizajeTrazability = () => import('@/views/traceability/DetailedRepaletizaje.vue');
const detailedLote = () => import('@/views/traceability/detailedLote.vue');
const detailedWaybillDispatch = () => import('@/views/traceability/detailedWaybillDispatch.vue');
const DetailedBording = () => import('@/views/traceability/DetailedBording.vue');
const DetaildedWaybillExport = () => import('@/views/traceability/DetaildedWaybillExport.vue');

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
const Page500 = () => import('@/views/pages/Page500');
const Login = () => import('@/views/pages/Login');
const Register = () => import('@/views/pages/Register');

// Bagno Views

const ArrivalForm = () => import('@/bagno_views/arrivals/form/Main.vue');
const DocumentList = () => import('@/bagno_views/arrivals/DocumentList.vue');
const DetailedStock = () => import('@/bagno_views/stock/DetailedStock.vue');
const AreaStock = () => import('@/bagno_views/stock/AreaStock.vue');
const DocumentAreaStock = () => import('@/bagno_views/stock/DocumentAreaStock.vue');
const TotalStock = () => import('@/bagno_views/stock/TotalStock.vue');
const ProcessForm = () => import('@/bagno_views/process/form/Main.vue');
const ProcessForm2 = () => import('@/bagno_views/process/form2/Main.vue');
const CreateProcess = () => import('@/bagno_views/process/form/CreateProcess.vue');
const BagnoProcessList = () => import('@/bagno_views/process/ProcessList.vue');
const DailyProcessList = () => import('@/bagno_views/process/DailyProcessList.vue');

//purchase Order
const purchaseOrderForm = () => import('@/views/purchaseOrder/Main.vue');
const purchaseOrderList = () => import('@/views/purchaseOrder/List.vue');

Vue.use(Router);


export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [

    {
      path: '/',
      beforeEnter (to, from, next) {
        if (store.state.token) {
          next()
        } else {
          next('/pages/login')
        }

      },
      redirect: '/inicio',
      name: 'Principal',
      component: DefaultContainer,
      children: [
        {
          path: 'inicio',
          name: 'Inicio',
          component: Inicio
        },

        // BAGNO
        {
          path: '/bagno/recepcion',
          redirect: '/inicio',
          name: 'bagno-recepcion',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'bagno-recepcion-ingreso',
              component: ArrivalForm
            },
            {
              path: 'listado',
              name: 'bagno-recepcion-listado',
              component: DocumentList
            },
          ]
        },
        {
          path: '/bagno/stock',
          redirect: '/inicio',
          name: 'bagno-stock',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'detalle',
              name: 'stock-detalle',
              component: DetailedStock
            },
            {
              path: 'total',
              name: 'stock-total',
              component: TotalStock
            },
            {
              path: 'area',
              name: 'stock-area',
              component: AreaStock
            },
            {
              path: 'por-lote',
              name: 'stock-por-lote',
              component: DocumentAreaStock
            },
          ]
        },
        {
          path: '/bagno/procesos',
          redirect: '/inicio',
          name: 'bagno-procesos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'bagno-procesos-ingreso',
              component: ProcessForm,
              props: { process_id: 3 }
            },
            {
              path: 'ingreso2',
              name: 'bagno-procesos-ingreso2',
              component: ProcessForm2,
              props: { process_id: 3 }
            },
            {
              path: 'crear',
              name: 'bagno-procesos-crear',
              component: CreateProcess,
            },
            {
              path: 'listado',
              name: 'bagno-procesos-listado',
              component: BagnoProcessList,
            },
            {
              path: 'reporte-proceso-dias',
              name: 'bagno-reporte-proceso-dias',
              component: DailyProcessList
            }
          ]
        },
        {
          path: '/recepcion',
          redirect: '/inicio',
          name: 'Recepción',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'Ingreso',
              component: Ingreso
            },
            {
              path: 'list',
              name: 'List',
              component: List
            },
            {
              path: 'consultas',
              name: 'Consultas',
              component: Consultas
            },
            {
              path: 'editar/:waybillID',
              name: 'Editar',
              props: true,
              component: Ingreso
            },
          ]
        },
        {
          path: '/proceso',
          redirect: '/inicio',
          name: 'Procesos',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'IngresoProceso',
              component: IngresoProceso
            },
             {
               path: '1/:typeProcess',
               name: 'Formulario Ingreso Proceso',
               props: true,
               component: IngresoProcesoyReproceso
            },
             {
               path: '2/:typeProcess',
               name: 'Formulario Ingreso Proceso',
               props: true,
               component: IngresoRepaletizaje
            },
            {
               path: '1/:typeProcess/editar/:processID',
               name: 'Formulario Ingreso Proceso',
               props: true,
               component: IngresoProcesoyReproceso
            },
            {
              path: 'list',
              name: 'lista',
              component: ProcessList
            },
          ]
        },
        {
          path: '/camara',
          redirect: '/inicio',
          name: 'Camara',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'stock',
              name: 'Stock',
              component: Stock
            },
            {
              path: 'camaras',
              name: 'Camaras',
              component: Position
            },
            {
              path: 'stock-castana',
              name: 'Stock-Castaña',
              component: StockCastana
            },
            {
              path: 'mapeo',
              name: 'Mapeo',
              component: MappingList,
            },
            {
              path: 'repaletizaje',
              name: 'Repaletizaje',
              component: IngresoRepaletizaje,
            },
          ]
        },
        {
          path: '/bodega',
          redirect: '/inicio',
          name: 'Bodega',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'Ingreso',
              component: CreateSupplyWaybill,
              props: { waybill_type: 3, edit_waybill: false } // 4 is dispatch, 3 is arrival
            },
            {
              path: 'salida',
              name: 'Salida',
              component: CreateSupplyWaybill,
              props: { waybill_type: 4, edit_waybill: false } // 4 is dispatch, 3 is arrival
            },
            {
              path: 'lista',
              name: 'Lista',
              component: ListSupplies,
            },
            {
              path: 'stock',
              name: 'Stock',
              component: StockSupplies,
            },
            {
              path: 'editar/:waybill_type/:waybillID',
              name: 'Editar',
              props: true,
              component: CreateSupplyWaybill,
              // props: { edit_waybill: true } // 1 is dispatch, 0 is arrival
            },

          ]
        },
        {
          path: '/despacho',
          redirect: '/inicio',
          name: 'Despacho',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'ingreso',
              name: 'ingreso',
              component: IngresoDespacho
            },
            {
              path: 'list',
              name: 'lista',
              component: ListDespacho
            },
            {
              path: 'editar/:waybillID',
              name: 'Editar',
              props: true,
              component: IngresoDespacho
            },
            {
              path: 'detalle_despacho/:waybillID',
              name: 'Detalle Despacho',
              props: true,
              component: DetalleDespacho
            },
          ]
        },
        {
          path: '/camara',
          redirect: '/inicio',
          name: 'Camara',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'stock',
              name: 'Stock',
              component: Stock
            },
            {
              path: 'camara',
              name: 'Camara',
              component: Position
            },
          ]
        },
        {
          path: '/exportacion',
          redirect: '/inicio',
          name: 'Exportacion',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
            path: 'instructivo-de-embarque',
            name: 'Instructivo de Embarque',
            component: InstruccionEmbarque
            },
             {
              path: 'list',
              name: 'Lista Instructivo de Embarque',
              component: ListInstruccionEmbarque
              },
              {
                path: 'editar/:BoardingID',
                name: 'Editar',
                props: true,
                component: InstruccionEmbarque
              },
              {
                path: 'inspeccion/',
                name: 'inspeccion',
                props: true,
                component: InspeccionEmbarque
              },
              {
                path: 'lista-inspeccion/',
                name: 'Lista Inspeccion',
                props: true,
                component: ListInspecciones
              },
              {
                path: 'aprobar/:idInspection',
                name: 'Aprobar',
                props: true,
                component: formAprobarPallet
              },
              {
                path: 'lista-embarque/',
                name: 'Lista Embarque/',
                props: true,
                component: ListaEmbarque
              },
              {
                path: 'despacho-guia-exportacion/',
                name: 'Despacho guia exportacion/',
                props: true,
                component: guiaDespachoExportacion
              },
              {
                path: 'lista-guia-exportacion/',
                name: 'Lista guia exportacion/',
                props: true,
                component: ListGuiaExportacion
              },
              {
                path: 'editar-guia-exportacion/:ExportGuiaID',
                name: 'Editar',
                props: true,
                component: guiaDespachoExportacion
              },
          ]
        },
        {
          path: '/reportes',
          redirect: '/inicio',
          name: 'Reportes',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'dashboard',
              name: 'Dashboard',
              component: Dashboard
            },
            {
              path: 'excel',
              name: 'Excel',
              component: Excel
            },
          ]
        },
        {
          path: '/comercial',
          redirect: '/inicio',
          name: 'Comercial',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'crear-proforma',
              name: 'Proforma',
              component: CreateProforma
            },
            {
              path: 'listar-proforma',
              name: 'Listar Proformas',
              component: ProformaList
            },
          ]
        },
        {
          path: '/calidad',
          redirect: '/inicio',
          name: 'Calidad',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'Lista',
              component: ListCalidad
            },
            {
              path: 'list-process',
              name: 'Lista procesos',
              component: ListProcess
            },
            {
              path: 'detailed-lot-inspection/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id/:index',
              name: 'Detalle Inspecciones',
              props: true,
              component: DetailedLot
            },
            {
              path: 'reports',
              name: 'Reportes',
              component: ReportExcel
            },
            {
              path: 'detailed-evaluations-lot/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id',
              name: 'Detalle Evaluaciones',
              props: true,
              component: ListEvaluationsReception
            },
            {
              path: 'detailed-evaluations-lot-process/:LotID/:NumLot/:typeInspectionID/:typeNameTypeInspection/:inspection_data_id',
              name: 'Detalle Evaluaciones Process',
              props: true,
              component: ListEvaluationsProcess
            },
          ]
        },
        {
          path: '/trazabilidad',
          redirect: '/trazabilidad/search',
          name: 'trazabilidad',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'search',
              name: 'buscar',
              component: Traceability
            },
            {
              path: 'detailed/:PalletID/:ContentID/:PalletNumber',
              name: 'Detalle',
              props: true,
              component: DetailedTraceability
            },
            {
              path: 'process-repaletting/:PalletID/:ContentID/:PalletNumber',
              name: 'Pallet-Repaletizado',
              props: true,
              component: DetailedRepaletizajeProcess
            },
            {
              path: 'detailed-waybill-reception/:waybill_id/:numGuia',
              name: 'Detalle-Guia',
              props: true,
              component: DetailedWaybillReception
            },
            {
              path: 'detailed-pallet-trazability/:PalletID/:NumeroPallet',
              name: 'detailed-pallet',
              props: true,
              component: DetailedPalletTrazability
            },
            {
              path: 'detailed-process/:process_id/:numProcess',
              name: 'Detalle-Process',
              props: true,
              component: DetaildedProcess
            },
            {
              path: 'detailed-repaletizaje/:process_id/:numProcess',
              name: 'Detalle-repa',
              props: true,
              component: DetailedRepaletizajeTrazability
            },
            {
              path: 'detailed-lote/:waybill_id/:numLote',
              name: 'Detalle-Lote',
              props: true,
              component: detailedLote
            },
            {
              path: 'detailed-waybill-dispatch/:waybill_id/:numGuia',
              name: 'Detalle-Guia-Despacho',
              props: true,
              component: detailedWaybillDispatch
            },
            {
              path: 'detailed-bording/:bording_id/:bording_number',
              name: 'Detalle-Embarque',
              props: true,
              component: DetailedBording
            },
            {
              path: 'detailed-waybill-export/:waybill_id/:numWaybill',
              name: 'Detalle-Guia-Exportacion',
              props: true,
              component: DetaildedWaybillExport
            }

          ]
        },
        {
          path: '/orden-de-compra',
          redirect: '/inicio',
          name: 'orden-de-compra',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'crear-orden-compra',
              name: 'crear-orden-compra',
              component: purchaseOrderForm
            },
            {
              path: 'lista-orden-compra',
              name: 'lista-orden-compra',
              component: purchaseOrderList
            }
          ]
        },
      ]
    },
     {
      path: '/pages',
      redirect: '/pages/login',
      name: 'Pages',
      component: LoginConenedor,
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
})
